import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { monthLabel } from "@/lib/month";

const HEAD = ["Staff", "Task", "Selesai", "Belum", "Overdue", "On-time %", "Hadir", "Telat", "Cuti", "Jam kerja", "Rata2/hari", "Score", "Grade"];

const toRow = (r) => [
  r.name,
  r.tasks.assigned,
  r.tasks.done,
  r.tasks.open,
  r.tasks.overdue,
  r.tasks.on_time_pct ?? "-",
  r.attendance.days_present,
  r.attendance.late_count,
  r.attendance.leave_days,
  r.attendance.total_hours,
  r.attendance.avg_hours,
  r.score ?? "-",
  r.grade ?? "-",
];

export function exportTeamCsv(rows, month) {
  const esc = (v) => `"${String(v).replace(/"/g, '""')}"`;
  const lines = [HEAD, ...rows.map(toRow)].map((l) => l.map(esc).join(","));
  const blob = new Blob(["\ufeff" + lines.join("\n")], { type: "text/csv;charset=utf-8" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = `team-performance-${month}.csv`;
  a.click();
  URL.revokeObjectURL(a.href);
}

export function exportTeamPdf(rows, month, propertyName) {
  const doc = new jsPDF({ orientation: "landscape" });
  doc.setFontSize(16);
  doc.text("BedsolvingOps - Team Performance", 14, 16);
  doc.setFontSize(10);
  doc.text(`${monthLabel(month)} - ${propertyName || "All properties"}`, 14, 23);
  doc.text("Score = % task selesai | 85+ Excellent | 70+ Good | 50+ Needs improvement | <50 Poor", 14, 29);
  autoTable(doc, {
    startY: 34,
    head: [HEAD],
    body: rows.map(toRow),
    styles: { fontSize: 8 },
    headStyles: { fillColor: [217, 102, 53] },
  });
  doc.save(`team-performance-${month}.pdf`);
}

export function exportChecklistCsv(groups, rows) {
  const cols = groups.flatMap((g) => g.columns);
  const head = ["Property name", ...cols.map((c) => c.label), "Remark"];
  const esc = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
  const lines = [head, ...rows.map((r) => [r.property_name, ...cols.map((c) => r.cells[c.key] || ""), r.cells.remark || ""])]
    .map((l) => l.map(esc).join(","));
  const blob = new Blob(["\ufeff" + lines.join("\n")], { type: "text/csv;charset=utf-8" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = "channel-checklist.csv";
  a.click();
  URL.revokeObjectURL(a.href);
}
